import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-registration-list',
  templateUrl: './vehicle-registration-list.component.html',
  styleUrls: ['./vehicle-registration-list.component.scss']
})
export class VehicleRegistrationListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
